import * as Yup from 'yup';
import { TemplateFormSSHConfigField } from '../TemplateFormSSHConfigField';
import { TemplateFormSshConfigFieldMeta } from '../interfaces/template-form-ssh-config-field-meta';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';

export const SSHFieldMeta: TemplateFormComponentMeta<
  TemplateFormSshConfigFieldMeta,
  {
    ssh_auth_keys?: {
      key: string;
      is_recommended: boolean;
      display_name: string;
      value: string;
    }[];
  }
> = {
  component: TemplateFormSSHConfigField,
  MetadataFactory: (field, disableEdit) => ({
    disabled: disableEdit || !!field.disabled,
    sshAuthKeys: (field.component?.ssh_auth_keys || []).map(authKey => ({
      key: authKey.key,
      displayName: authKey.display_name,
      recommended: authKey.is_recommended,
      value: authKey.value
    }))
  }),
  ValidationSchemaFactory: field =>
    Yup.object().shape({
      [field.name]: Yup.boolean().nullable(),
      ssh_host: Yup.string()
        .trim()
        .when([field.name], (sshEnabled, schema) => {
          return sshEnabled ? schema.trim().required() : schema.nullable();
        }),
      ssh_user: Yup.string()
        .trim()
        .when([field.name], (sshEnabled, schema) => {
          return sshEnabled ? schema.trim().required() : schema.nullable();
        }),
      ssh_port: Yup.number().when([field.name], (sshEnabled, schema) => {
        return sshEnabled ? schema.required().min(1) : schema.nullable();
      })
    })
};
